import { useParams } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import { LoadingSpinner } from 'src/consumer/components/Loaders'
import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
} from 'src/mentor/helpers/utilityFunctions'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import ClinicEngagementModels from 'src/supportPortal/views/engagementModels/ClinicEngagementModels'

export default function SingularClinicEngagementModels() {
  const { brandSlug } = useParams()
  const [clinicBrand, setClinicBrand] = useState()
  async function getClinicBrand() {
    const resp = await getSPDataWithParams(`/api/secure/cc/support/clinic-brand/get`, {
      slug: brandSlug,
    })
    if (resp.status === 200) {
      if (isCommonResponseSuccessfulV2(resp)) {
        const brand = getDataMapFromCommonResponse(resp)?.['clinic-brand']
        setClinicBrand(brand)
      }
    }
  }

  console.log({ clinicBrand })

  useEffect(() => {
    getClinicBrand()
  }, [])

  return !clinicBrand ? (
    <LoadingSpinner />
  ) : (
    <ClinicEngagementModels clinicBrandData={clinicBrand} hideClinicBrandDropDown />
  )
}
